const amazonItemImgUrl = (url?: string, size = 250, autoCrop = false) => (
    !url ? undefined :
    `${url.replace(".jpg", "")}._${autoCrop ? "AC_SL": "SS"}${size}_.jpg`
)

export default amazonItemImgUrl